module.exports = __webpack_public_path__ + "img/corporate_04.bcd3da37.png";